const Tax = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "rate": "المعدل",
    "tax_type": "نوع الضريبة",
    "search": "بحث",

    // PAGE HEADER
    "tax": "الضريبة",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",
    "error_tax_rate": "الرجاء إدخال معدل الضريبة",
    "error_positive": "يجب أن يكون الرقم موجبًا",
    "error_tax_type": "الرجاء اختيار نوع الضريبة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_rate": "المعدل",
    "table_tax_type": "نوع الضريبة",

}

export default Tax;